module.exports = __webpack_public_path__ + "img/1450681484.485628e6.jpg";